import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'
import { orderExcursionsStore } from 'entities/excursions/models/order-excursions/order-excursions-store'
import userStore from 'entities/user/module/user-store'

import { ShareKeys } from 'shared/constants'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'

import { ParticipantsCounter } from './components/participants-counter'
import { StartDateInfo } from './components/start-date-info'
import { TimeAndPlaceInfo } from './components/time-and-place-info'
import { TotalPrice } from './components/total-price'
import s from './styles.module.scss'

const OrderDetail = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const currentExcursion = listExcursionStore.currentExcursionsDetail

  const price = currentExcursion?.is_promo
    ? currentExcursion?.new_price
    : currentExcursion?.price

  useEffect(() => {
    const raw = userStore.getClientStateParse<{
      excursionDetails?: typeof currentExcursion
    }>(ShareKeys.excursion)
    if (!raw || typeof raw !== 'object' || !raw.excursionDetails) {
      return
    }

    listExcursionStore.onSetCurrentExcursionsDetail(raw.excursionDetails)
  }, [userStore.client_state])

  useEffect(() => {
    if (currentExcursion) {
      orderExcursionsStore.onChangeExcursionId(currentExcursion.id)
      orderExcursionsStore.onChangeBonus(
        currentExcursion.is_bonus,
        currentExcursion.bonus_amount,
      )
      orderExcursionsStore.onTotalPriceChange(
        Number(price) *
          orderExcursionsStore?.orderExcursionInfo?.people_quantity,
        currentExcursion?.tranche_amount,
      )
    }
  }, [currentExcursion])

  useEffect(() => {
    orderExcursionsStore.onPeopleQuantityChange(
      orderExcursionsStore?.orderExcursionInfo?.people_quantity,
    )
  }, [])

  return (
    <div className="container">
      {!currentExcursion ? (
        <Loader
          type="excursions"
          marginTop={200}
        />
      ) : (
        <>
          <HeaderGoBack
            title={t('beket.order_detail')}
            buttonWhite
          />

          <div className={s.orderDetails}>
            <StartDateInfo currentExcursion={currentExcursion} />

            <TimeAndPlaceInfo currentExcursion={currentExcursion} />

            <ParticipantsCounter
              price={price}
              currentExcursion={currentExcursion}
              count={orderExcursionsStore?.orderExcursionInfo?.people_quantity}
            />

            <TotalPrice
              isMBonus
              price={price}
              MBonusCount={currentExcursion.bonus_amount}
              count={orderExcursionsStore?.orderExcursionInfo?.people_quantity}
            />

            <ButtonContinue
              onClick={() =>
                navigate(RoutingPaths.excursion.customerDetails.path())
              }
            >
              <span className={s.continue}>{t('continue')}</span>
            </ButtonContinue>
          </div>
        </>
      )}
    </div>
  )
})

export default OrderDetail
